export default class EventsBlock {
    constructor() {
        
    }
}

new EventsBlock();


// WEBPACK FOOTER //
// ../views/modules/events-block/assets/js/events-block.js